// extracted by mini-css-extract-plugin
export default {"header":"OQ","container":"PQ","accordeonitem":"QQ","itemsticky":"RQ","itemopen":"SQ","open":"TQ","productname":"UQ","productinfo":"VQ","flavorstext":"WQ","invalidlimit":"XQ","limit":"YQ","scrollUpAccordion":"ZQ","wrapper":"aR"};
    if(module.hot) {
      // 1714442370887
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  